const config = {
  SENTEC_ACCOUNTS_PROFILE: process.env.VUE_APP_API_ACCOUNT_URL,
  SENTEC_ACCOUNTS_URL: process.env.VUE_APP_WEB_ACCOUNT_URL,
  BASE_API_URL: process.env.VUE_APP_API_APP_URL,
  BASE_API_URL_FO: process.env.VUE_APP_API_FO_URL,
  BASE_API_URL_POS: process.env.VUE_APP_API_POS_URL,
  BASE_WS_URL_FO: process.env.VUE_APP_WEB_FO_URL,
  BASE_WS_URL_POS: process.env.VUE_APP_WEB_POS_URL,
  IS_ONLINE_URL: process.env.VUE_APP_IS_ONLINE_URL,
  SENTEC_PUBSUB_URL: process.env.VUE_APP_SENTEC_PUBSUB_URL,
  GOOGLE_CLIENT_ID: "",
  STORAGE_KEYS: {
    TOKEN: "arch-pms-token",
    PREV_PAGE: "prev",
    NEXT_PAGE: "next"
  },
  TB_DUMMY_DATA: process.env.VUE_APP_TB_DUMMY_DATA,
  ST_WEB_FO: process.env.VUE_APP_WEB_FO_URL,
  // Sentec file storage endpoints
  ST_STORAGE_STATIC_URL: process.env.VUE_APP_STORAGE_STATIC_URL, // Uploaded files (all)
};

export default config;
